import { FC, memo, useMemo } from 'react'
import {
  CompanyType,
  EstimatedProjectValueBand,
  PlanningApplicationStatus,
  PlanningApplicationType,
  PlanningCategory,
  PlanningClassification,
} from '@leadgen/models/client'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { filterSummaryFormatter } from '../../../../formatters/filterSummaryFormatter'

const FilterSummary: FC<{
  companyType: CompanyType | null
  planningApplicationTypes: PlanningApplicationType[]
  planningApplicationStatuses: PlanningApplicationStatus[]
  planningClassifications: PlanningClassification[]
  planningCategories: PlanningCategory[]
  estimatedProjectValueBands: EstimatedProjectValueBand[]
}> = ({
  companyType,
  planningApplicationTypes,
  planningApplicationStatuses,
  planningClassifications,
  planningCategories,
  estimatedProjectValueBands,
}) => {
  const summarySections = useMemo(
    () =>
      filterSummaryFormatter.formatSelectedFilters({
        companyType,
        planningApplicationTypes,
        planningApplicationStatuses,
        planningClassifications,
        planningCategories,
        estimatedProjectValueBands,
      }),
    [
      companyType,
      estimatedProjectValueBands,
      planningApplicationStatuses,
      planningApplicationTypes,
      planningCategories,
      planningClassifications,
    ],
  )

  return (
    <Box
      sx={{
        margin: 2,
        padding: 2,
        borderRadius: 2,
        border: theme => `1px solid ${theme.palette.divider}`,
        backgroundColor: 'white',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 700, marginBottom: 1.5 }}>
        Selected filter summary
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
          gap: 1.5,
        }}
      >
        {summarySections.map(section => (
          <Box key={section.label}>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: 'block', fontWeight: 700, textTransform: 'uppercase' }}
            >
              {section.label}
            </Typography>
            <Typography variant="body2">{section.text}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default memo(FilterSummary)
